 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"dialogues":"dialogues","main":"main"}[chunkId]||chunkId) + "." + {"chunk-0ed564c3":"fe2f0ba1","chunk-0f535076":"8b4dc485","chunk-144b3204":"9393e782","chunk-264ab418":"5f37d308","chunk-41520ef4":"3e84f1f5","chunk-54b56a30":"f6b259e2","chunk-10c5f8dc":"27e37981","chunk-8681934a":"60ee5a0f","chunk-6bbbc6ca":"1af73611","chunk-6ed637ee":"292b9eaa","chunk-5d41845a":"4f048b19","chunk-696f343a":"219a7194","chunk-aadee2ba":"e34c4ca2","chunk-c1d3468a":"5852fac0","chunk-983c042e":"c794b2aa","chunk-50ccbdfc":"2a6a1ec2","chunk-82cb8220":"b976c847","chunk-2d0be336":"4c0b9219","chunk-3493437c":"3fa68dbb","chunk-0c5fb086":"9660264d","chunk-5b08e81b":"d0f0a85d","chunk-3576e228":"e73336fa","chunk-35a4173a":"bbe45cd2","chunk-41d3ff30":"628dd502","chunk-4495a134":"500a4fcf","chunk-4cbf1f02":"0578c644","chunk-3ca9011b":"7e5e8222","chunk-46d076d3":"10d9afdb","chunk-67a82981":"c8ab7e23","chunk-d0b7167a":"98eecb19","chunk-13d1c617":"70a3c691","chunk-5a5e503e":"c00581df","chunk-8c6848a6":"821a0e13","chunk-72acc005":"41d31ea4","chunk-78b9527b":"a84aecd6","chunk-79a06bde":"e6b8c149","chunk-9ca41548":"3e22d7b3","chunk-a791f378":"e32b91a4","chunk-a9b4e1c8":"70b8335d","chunk-b2f05fd6":"dd33f1cd","chunk-dc79a44a":"6c51921a","chunk-df68eaae":"12f491b1","dialogues":"2a3f1e72","main":"e179e6a9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0ed564c3":1,"chunk-0f535076":1,"chunk-144b3204":1,"chunk-41520ef4":1,"chunk-54b56a30":1,"chunk-10c5f8dc":1,"chunk-8681934a":1,"chunk-6bbbc6ca":1,"chunk-6ed637ee":1,"chunk-5d41845a":1,"chunk-696f343a":1,"chunk-aadee2ba":1,"chunk-c1d3468a":1,"chunk-983c042e":1,"chunk-50ccbdfc":1,"chunk-82cb8220":1,"chunk-0c5fb086":1,"chunk-5b08e81b":1,"chunk-3576e228":1,"chunk-35a4173a":1,"chunk-41d3ff30":1,"chunk-4495a134":1,"chunk-3ca9011b":1,"chunk-46d076d3":1,"chunk-67a82981":1,"chunk-d0b7167a":1,"chunk-13d1c617":1,"chunk-5a5e503e":1,"chunk-8c6848a6":1,"chunk-72acc005":1,"chunk-78b9527b":1,"chunk-79a06bde":1,"chunk-9ca41548":1,"chunk-a791f378":1,"chunk-a9b4e1c8":1,"chunk-b2f05fd6":1,"chunk-dc79a44a":1,"chunk-df68eaae":1,"main":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"dialogues":"dialogues","main":"main"}[chunkId]||chunkId) + "." + {"chunk-0ed564c3":"cde7c71c","chunk-0f535076":"ae4b7c3c","chunk-144b3204":"3f935b23","chunk-264ab418":"31d6cfe0","chunk-41520ef4":"e4e32097","chunk-54b56a30":"d705f4d9","chunk-10c5f8dc":"ea4ff1df","chunk-8681934a":"8ef6059b","chunk-6bbbc6ca":"8b08882b","chunk-6ed637ee":"c453ed42","chunk-5d41845a":"5bb5405f","chunk-696f343a":"cda8c4eb","chunk-aadee2ba":"0e74f5a9","chunk-c1d3468a":"cecc5668","chunk-983c042e":"a5549217","chunk-50ccbdfc":"fde597e0","chunk-82cb8220":"1fe32dda","chunk-2d0be336":"31d6cfe0","chunk-3493437c":"31d6cfe0","chunk-0c5fb086":"768804b4","chunk-5b08e81b":"fb5ac618","chunk-3576e228":"9151bc6d","chunk-35a4173a":"88e90275","chunk-41d3ff30":"22ed09bd","chunk-4495a134":"5ac58721","chunk-4cbf1f02":"31d6cfe0","chunk-3ca9011b":"d0c55f88","chunk-46d076d3":"1cf8e005","chunk-67a82981":"dde860a5","chunk-d0b7167a":"56fd4e42","chunk-13d1c617":"a588ea6d","chunk-5a5e503e":"fae9c5c2","chunk-8c6848a6":"95580069","chunk-72acc005":"e96456a2","chunk-78b9527b":"e96456a2","chunk-79a06bde":"4ea0694f","chunk-9ca41548":"c7d8f317","chunk-a791f378":"78f47702","chunk-a9b4e1c8":"2e90c0c2","chunk-b2f05fd6":"aa327be8","chunk-dc79a44a":"e0d9fb03","chunk-df68eaae":"204c17bc","dialogues":"31d6cfe0","main":"702a8db4"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.guoranbot.com/cdn-scrm/test/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
